import { useCallback, useEffect, useState } from 'react';
import { ReadBankingRules } from 'services/distributor';
import { parseCurrency } from 'utils/parsers';
import { BICard, BIContainer } from './styled';

export default function BankingCadsRules({ distribuidor }) {
  const [regras, setRegras] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => setTick((prev) => prev + 1), 120000);
    return () => clearInterval(interval);
  }, []);

  const init = useCallback(async () => {
    setLoading(true);
    try {
      const res = await ReadBankingRules(distribuidor);
      setRegras(res);
    } catch (err) {
      console.error('Erro ao carregar regras', err);
    } finally {
      setLoading(false);
    }
  }, [distribuidor]);

  useEffect(() => init(), [tick, init]);

  if (loading || !regras?.banking_regras_gerais) {
    return <div>Carregando indicadores...</div>;
  }

  return (
    <BIContainer>
      <BICard>
        <label>cdc utilizado</label>
        <div className="value">
          {parseCurrency(regras.banking_regras_gerais.valor_cdc_utilizado)}
        </div>
        <div className="footer">
          de {parseCurrency(regras.banking_regras_gerais.valor_cdc)}
        </div>
      </BICard>
      {regras.banking_regras_aprovacao.map(
        (perfil) =>
          perfil.perfil_cliente !== 'D' && (
            <BICard key={perfil.id}>
              <label>Perfil: {perfil.perfil_cliente}</label>
              <div className="value">
                {perfil.valor_teto !== 0
                  ? `${((perfil.concentracao_utilizada / regras.banking_regras_gerais.valor_cdc_utilizado) * 100).toFixed(1)}%` ===
                    'NaN%'
                    ? '0%'
                    : `${((perfil.concentracao_utilizada / regras.banking_regras_gerais.valor_cdc_utilizado) * 100).toFixed(1)}%`
                  : '--'}
              </div>
              <div className="footer">
                {parseCurrency(perfil.concentracao_utilizada)}/
                {parseCurrency(perfil.valor_teto)}
              </div>
            </BICard>
          )
      )}
    </BIContainer>
  );
}
